// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"19":"6066304d","143":"6c03e527","167":"1fbb1b6f","480":"1ff27934","667":"b72671dd"}[chunkId] + ".js";
};